<template lang="html">
    <div id="vue-pagescreate" class="container px-0 mb-4">
        <router-view />
    </div>
</template>

<script>
import Vue from "vue";
import router from "./routes/router.js";
import store from "./store/store.js";
import axios from "axios";
import qs from "qs";
import PagesServicePlugin from "./components/inc/PagesServicePlugin.vue";
import BeneficiaryServicePlugin from "./components/inc/BeneficiaryServicePlugin.vue";
import GfImagePlugin from "./components/inc/GfImagePlugin.vue";
import VueScrollTo from "vue-scrollto";
import WowJs from "wowjs";
import { VueLoggerPlugin } from "@gf/gf-logger";

Vue.use(VueLoggerPlugin);

export default {
	name: "GfPagescreate",
	router,
	store,
	props: [
		"store",
		"region",
		"regionId",
		"referrer",
		"captchaPublicKey",
		"facebookAppId",
		"facebookScope",
		"beneficiaryId",
		"eventId",
		"teamId",
		"user",
		"login",
		"externalId",
		"apiDomain",
		"pageType",
		"activationId",
		"pageId",
		"redirectUrl",
	],

	created: async function () {
		var vm = this;
		new WowJs.WOW().init();

		vm.setupServicePlugins();

		this.$store.commit("setApiDomain", this.apiDomain);
		this.$store.commit("setReferrer", this.referrer);

		if (this.region && this.region.length > 0)
			this.$store.commit("setRegion", this.region);

		if (this.regionId && this.regionId.length > 0)
			this.$store.commit("setRegionId", this.regionId);

		this.$store.commit("setCaptchaKey", this.captchaPublicKey);
		this.$store.commit("setFacebookScope", this.facebookScope);
		this.$store.commit("setFacebookAppId", this.facebookAppId);
		this.$store.commit("setRedirectUrl", this.redirectUrl);

		if (this.activationId && this.activationId.length > 0)
			this.$store.commit("setActivationId", this.activationId);
		if (this.pageId && this.pageId.length > 0)
			this.$store.commit("setPageId", this.pageId);

		this.$gfLogger.logInfo('GfPagescreate.created(), this.teamId', this.teamId);
		if (this.teamId && this.teamId != "") {
			this.$store.commit("pre_TeamId", this.teamId);

			await this.$pagesService
				.getTeamPage(this.teamId)
				.then(function (pageDetails) {
					if (pageDetails !== null) {

						vm.$store.commit("setPageType", "joinTeam");
						vm.$store.commit("change_jointeam_data", {
							page: pageDetails,
							Router_Name: "select_team",
						});

						vm.$router.push({
							name: "complete_jointeam",
						});
					}
					else {
						vm.$store.commit("pre_TeamId", '');
						vm.$store.commit("setPageType", "individual");
						vm.$router.push("/individual/charity");
					}
				});
		}

		if (this.beneficiaryId && this.beneficiaryId !== "")
			await this.doBeneficiaryValidityCheck();
		
		if (this.eventId && this.eventId.id != "") {
			if (this.$store.state.data_params_pre.beneficiaryId === "" && this.$router.currentRoute.name === "dashboard")
				await this.doSingleBeneficiaryCheck();

			this.$store.commit("pre_EventId", this.eventId);
			this.$store.commit("change_event", {
				EventCampaignId: this.$store.state.data_params_pre.eventId.id,
				EventName: this.$store.state.data_params_pre.eventId.name,
				EventImagePath: this.$store.state.data_params_pre.eventId
					.ImagePath,
				EventUrl: window.location.origin,
				Router_Name: "event_individual",
			});
		}

		if (this.user != "") {
			this.$store.commit("preUserLogin", this.user);
		}

		if (this.externalId != "") {
			this.$store.commit("pre_ExternalId", this.externalId);
		}

		if (this.login) {
			this.$store.commit("pre_Login", this.login);
		}

		this.$gfLogger.logInfo('GfPagescreate.created(), this.pageType', this.pageType);
		if (this.pageType) {
			if (this.pageType.toLowerCase() === "team") {
				this.$router.push("/team/charity");
			}

			if (this.pageType.toLowerCase() === "individual") {
				this.$router.push("/individual/charity");
			}
		}
		this.$store.commit("appReadyForUserInput");
	},

	mounted: function () {
		this.scrollToComponent();
	},

	methods: {
		setupServicePlugins: function () {
			var servicePluginOptions = {
				apiDomain: this.apiDomain,
				region: this.region,
				store: this.$store,
			};

			Vue.use(PagesServicePlugin, servicePluginOptions);
			Vue.use(BeneficiaryServicePlugin, servicePluginOptions);
			Vue.use(GfImagePlugin);
		},

		scrollToComponent: function () {
			setTimeout(() => {
				VueScrollTo.scrollTo("#vue-pagescreate", "100", {
					easing: "ease-in",
					offset: -60,
					force: true,
				});
			}, 1000);
		},

		async doSingleBeneficiaryCheck() {
			var self = this;
			var res = await this.$beneficiaryService.searchByEvent(
				this.eventId.id
			);
			if (res.data && res.data.ResultsReturned === 1) {
				var beneficiaryDetails = {
					id: res.data.Beneficiaries[0].BeneficiaryAccountId,
					ImagePath: res.data.Beneficiaries[0].BeneficiaryImagePath,
					name: res.data.Beneficiaries[0].BeneficiaryName,
				};
				self.updateBeneficiaryDetails(beneficiaryDetails);
			}
		},

		async doBeneficiaryValidityCheck() {
			var self = this;
			var res;
			if (this.eventId && this.eventId.id && this.eventId.id != "")
				res = await this.$beneficiaryService.getBeneficiaryDetailsForEvent(
					this.beneficiaryId,
					this.eventId.id
				);
			else
				res = await this.$beneficiaryService.getBeneficiaryById(
					this.beneficiaryId
				);

			if (res.data && res.data.ResultsReturned === 1) {
				var beneficiaryDetails = {
					id: res.data.Beneficiaries[0].BeneficiaryAccountId,
					ImagePath: res.data.Beneficiaries[0].BeneficiaryImagePath,
					name: res.data.Beneficiaries[0].BeneficiaryName,
				};
				self.updateBeneficiaryDetails(beneficiaryDetails);
			} else {
				this.$store.commit("pre_BeneficiaryId", "");
			}
		},

		updateBeneficiaryDetails(details) {
			this.$store.commit("pre_BeneficiaryId", details);
			this.$store.commit("change_Beneficiary", {
				beneficiaryId: details.id,
				BeneficiaryName: details.name,
				BeneficiaryImagePath: details.ImagePath,
				Router_Name: "charity_individual",
			});
		},
	},
};
</script>

<style lang="css">
@import "assets/css/animate.min.css";

* {
	font-size: 14px;
	font-family: "bariolregular", "Roboto", sans-serif;
}

@font-face {
	font-family: "bariolbold";
	src: url("assets/fonts/Bariol_Bold.otf") format("opentype");
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: "bariolregular";
	src: url("assets/fonts/Bariol_Regular.otf") format("opentype");
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: "Flaticon-gf";
	src: url("assets/fonts/Flaticon.eot");
	src: url("assets/fonts/Flaticon.eot?#iefix") format("embedded-opentype"),
		url("assets/fonts/Flaticon.woff") format("woff"),
		url("assets/fonts/Flaticon.ttf") format("truetype"),
		url("assets/fonts/Flaticon.svg#Flaticon") format("svg");
	font-weight: normal;
	font-style: normal;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
	@font-face {
		font-family: "Flaticon";
		src: url("assets/fonts/Flaticon.svg#Flaticon") format("svg");
	}
}

#btn-submit {
	background-color: #f57c33;
	color: #fff;
	border-radius: 16px;
}

.using-fb {
	display: flex;
}
.error-message {
	color: red;
}
.statusLogin {
	cursor: pointer;
	color: #007bff !important;
}
.stLogout {
	cursor: pointer;
	color: #f47d32 !important;
}
.lazy-load {
	position: relative;
	left: 50%;
	transform: translateX(-50%);
}
.image_loading_search {
	position: absolute;
	right: 4%;
	top: 50%;
	transform: translateY(-50%);
	z-index: 10;
}
.image_loading_search img {
	width: 60%;
}
.lazy-load img {
	width: 75%;
}
.using-fb .hr-p {
	flex: 1;
	position: relative;
}

.using-fb .hr-p:before {
	content: "";
	background-color: #e9edf0;
	height: 1px;
	width: 100%;
	position: absolute;
	bottom: 50%;
}

.using-fb .text-us {
	flex: 1;
}
.using-fb .text-us h3,
.text-small {
	font-size: 0.95em;
	font-weight: 300;
}

.search_result {
	background-color: #f6f6f6;
	position: absolute;
	z-index: 10;
	width: 95%;
}
.search_result ul {
	margin-bottom: 0;
}
.search_result li {
	padding: 10px;
	color: #666363;
	border-bottom: 1px solid #ddd;
	cursor: pointer;
}

.card_box .card {
	overflow: hidden;
	border: 2px solid #dedede;
	background-color: #e8e8e86b !important;
}
@media (hover: hover) {
	.card_box .card:hover {
		cursor: pointer;
		border: 2px solid #f47d32 !important;
		-webkit-transition: all 0.5s;
	}

	.card_box .card:hover .success_hv {
		display: block;
		-webkit-transition: all 0.5s;
	}

	.search_result li:hover {
		background-color: #c1c1c1;
		color: #fff;
	}

	.png-wrap a:hover {
		text-decoration: none;
	}
}

.card_box .card .card-body {
	background-color: #e8e8e86b;
	font-size: 13px;
	color: rgb(0, 0, 0);
}
.card-text {
	max-width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.none_params {
	display: inline-block;
}

/* square_item */
.square_item {
	float: left;
	position: relative;
	width: 100%;
	padding-bottom: 100%;
	overflow: hidden;
}
.square_item .content {
	position: absolute;
	height: 100%;
	width: 100%;
	left: 0;
}
.square_item .table {
	display: table;
	width: 100%;
	height: 100%;
}
.table-cell {
	display: table-cell !important;
}
.cpl-event .square_item {
	height: 80px;
}
/* end square_item */

.success_hv {
	position: absolute;
	right: 5px;
	top: 2px;
	display: none;
	z-index: 1;
}
.success_hv:before {
	font-size: 1.5em;
	color: #f57c33;
}
.remove_item_card {
	position: absolute;
	right: 5px;
	top: 2px;
	z-index: 1;
}
.remove_item_card:before {
	color: #f57c33;
	padding: 0px 4px;
	font-size: 1.5em;
}

input[type="text"],
input[type="password"],
.date-dropdown-select {
	border-radius: 0px;
	font-size: 14px;
}

input:focus,
button:focus {
	box-shadow: none !important;
}
.png-wrap {
	border-bottom: 1px solid #f2f2f2;
	margin-bottom: 24px;
	border-radius: 0;
}

li.nav-breadcrumbs.selected,
li.nav-breadcrumbs.selected a {
	color: green;
}

.nav-breadcrumbs a {
	color: #1a3a49;
}

.back-btn {
	color: green;
	position: relative;
	bottom: 0px;
	cursor: pointer;
	font-size: 0.8em;
}

.png-wrap .active {
	border-bottom: 2px solid #1a3a49;
	margin-bottom: 0;
}

.ds_label {
	font-size: 14px;
}

button.btn-search {
	background-color: #fff;
	border: 1px solid #ccc;
	height: 100%;
}
button.btn-search:before {
	font-family: "Flaticon-gf";
	content: "\f103";
}
p.pag-gap {
	color: #bbbaba;
	font-weight: bold;
	letter-spacing: 2px;
}
.disabled a,
.disabled:before {
	cursor: default;
	color: #bbbaba;
}

.fl-type:before {
	content: "\f104";
}

.gf-heading-team:before {
	font-family: "Flaticon-gf";
	content: "\f105";
}

.content_charity {
	height: 500px;
	overflow-y: scroll;
}
.success_event img {
	width: 100%;
	height: 100px;
}
.or-hr {
	background-color: #989898;
	height: 1px;
	width: 23%;
}
.bd-hr-col {
	border-bottom: 1px solid #e9edf0;
}

.cpl-event .card-body {
	background-color: #ffffff;
	padding-left: 0;
	padding-right: 0;
	font-size: 13px;
}

a.router-link-active {
	color: #1a3a49;
}

.cpl-event .card-text {
	font-family: "bariolbold";
	font-size: 16px;
}

.head-complete {
	background-color: #f1f1f1;
}
.head-complete p {
	font-weight: bold;
}
.tab-model-gf-event .nav-link.active {
	background-color: #fff;
	color: #f47d32;
}
.tab-model-gf-event .nav-link {
	background-color: #e8e8e8;
	color: #999;
}
.gf-model-header {
	background-color: #f1f1f1;
}
#fblog {
	background-color: #3b5a9a;
	color: #fff;
	border-radius: 21px;
}
#fblog:before {
	font-family: "Flaticon-gf";
	content: "\f106";
}

.card_selected {
	border-color: orange !important;
}
.bg-light-grey {
	background-color: #e8e8e86b !important;
}
</style>
